import { Injectable } from '@angular/core';
import {Description} from '../../registration/services/bos.service';
import { DataAccessService } from '../../shared/services/dataaccess.service';
import { Configuration } from './../../app.constants';

export class GridColumns {
  caption: string;
  dataField: string;
  width: number;
  dataType: string;
  cssClass: string;
  allowSorting: boolean;
  visible:boolean;
};

let gridColumns: GridColumns[] = [
  {
    "caption": '#',
    "dataField": "CourseID",
    "width":50,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Course Name',
    "dataField": "CourseName",
    "width": 150,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Admission Mode',
    "dataField": "EntranceExamFlagName",
    "width": 100,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'College Name',
    "dataField": "CollegeName",
    "width": 150,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": true,
    "visible":true
  },
  {
    "caption": 'Form Submitted Date',
    "dataField": "FormSubDate",
    "width": 100,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": true,
    "visible":true
  },
  {
    "caption": 'Status',
    "dataField": "ApplicationStatus",
    "width": 100,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": true,
    "visible":true
  }
];

let courseColumns = [
  {
    "caption": 'Description',
    "dataField": "Description",
    "width":250,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Status',
    "dataField": "Status",
    "width"    : 200,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true,
    'encodeHtml': false
  },
  {
    "caption": 'Details',
    "dataField": "Details",
    "width": 300,
    "dataType": "string",
    "cssClass": "text-left thirdcolumn",
    "allowSorting": false,
    "visible":true,
    'encodeHtml': false
  },
  {
    "caption": '',
    "dataField": "CourseButton",
    "width": 150,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true,
    'encodeHtml': false
  },
  {
    "caption": '',
    "dataField": "CourseButton1",
    "width": 100,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true,
    'encodeHtml': false
  }
];
let PreStudentcourseColumns = [
  {
    "caption": 'Description',
    "dataField": "Description",
    "width":250,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Status',
    "dataField": "Status",
    "width"    : 200,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true,
    'encodeHtml': false
  },
  {
    "caption": 'Description',
    "dataField": "Description1",
    "width":250,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Status',
    "dataField": "Status1",
    "width"    : 200,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true,
    'encodeHtml': false
  },
  {
    "caption": '',
    "dataField": "CourseButton",
    "width": 150,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true,
    'encodeHtml': false
  }
];
let examColumns = [
  {
    "caption": 'Description',
    "dataField": "Description",
    "dataType": "string",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Status',
    "dataField": "Status",
    "width"    : 200,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true,
    'encodeHtml': false
  },
  {
    "caption": 'Description',
    "dataField": "Description1",
    "dataType": "string",
    "allowSorting": false,
    "visible":true
  },
  {
    "caption": 'Status',
    "dataField": "Status1",
    "width"    : 200,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true,
    'encodeHtml': false
  },
  {
    "caption": '',
    "dataField": "CourseButton",
    "width": 150,
    "dataType": "string",
    "cssClass": "text-center",
    "allowSorting": false,
    "visible":true,
    'encodeHtml': false
  }
];


export class SemisterWiseStudentInfo{
  SemisterId:number;
  SemisterName: string;
  AcademicYear:string;
  PasingYear:string;
  Status:String;
}

let semisterWiseStudent: SemisterWiseStudentInfo[] = [{
  SemisterId:1,
  SemisterName:"Semister 1",
  AcademicYear:"2016-2017",
  PasingYear :"2016-2017",
  Status : "Pass"
},
{
  SemisterId:2,
  SemisterName:"Semister 2",
  AcademicYear:"2016-2017",
  PasingYear :"2016-2017",
  Status : "Pass"
},
{
  SemisterId:3,
  SemisterName:"Semister 3",
  AcademicYear:"2017-2018",
  PasingYear :"2017-2018",
  Status : "Pass"
},
{
  SemisterId:4,
  SemisterName:"Semister 4",
  AcademicYear:"2017-2018",
  PasingYear :"2017-2018",
  Status : "Pass"
},
{
  SemisterId:5,
  SemisterName:"Semister 5",
  AcademicYear:"2018-2019",
  PasingYear :"2018-2019",
  Status : "Pass"
},
{
  SemisterId:6,
  SemisterName:"Semister 6",
  AcademicYear:"2018-2019",
  PasingYear :"2018-2019",
  Status : "Pass"
},
];

export class PreStudentInformationDashBoard
{
     StudentID:number  ;
     StudentName :string; 
     StudentLocalAddress :string;  
     StudentLocalAddress2 :string; 
     StudentPhoto  :string; 
     StudentSign:string;
     CourseName :string;  
     EntranceExamFlagName :string; 
     CollegeName :string;  
     FormSubDate :string;  
     ApplicationStatus :string; 
     CourseID: number;  
     InstanceName:string;
     GMerit:string;
     PRNNO:string;
}
export class UsertDetailsStatus
{
     StudentID:number;
     StatusID :number; 
     StatusName :string;  
     StatusFlag :string; 
     profilePicPath:string;
     chk:boolean;
}

export class CoursesSelected {
  CourseID: number;
  CourseName: string;
  AdmissionMode: string;
  CollegeName: string;
  FormSubmittedDate: string;
  Status: string;
  BranchName: string;
  Description: any;
  StudentPhoto  :string; 
}

export class Hallticket{
  IsSuccess:boolean;
  Data:string;
  Message:string;
}
export class ImageSize{
  PhotoSize:number;
  SignSize:number;
}

let profileStatusdefault: UsertDetailsStatus[] = [
    {
      StudentID:0,
      StatusID :1, 
      StatusName :"Personal Info I",  
      StatusFlag :"N", 
      profilePicPath:"../../../../assets/app/media/img/users/student.jpg",
      chk:false
    },
    {
      StudentID:0,
      StatusID :2, 
      StatusName :"Personal Info II",  
      StatusFlag :"N", 
      profilePicPath:"../../../../assets/app/media/img/users/student.jpg",
      chk:false
    },
    {
    StudentID:0,
    StatusID :3, 
    StatusName :"Address",  
    StatusFlag :"N", 
    profilePicPath:"../../../../assets/app/media/img/users/student.jpg",
      chk:false
    },
    {
      StudentID:0,
      StatusID :4, 
      StatusName :"Photo & Signature",  
      StatusFlag :"N", 
      profilePicPath:"../../../../assets/app/media/img/users/student.jpg",
      chk:false
    },
    {
      StudentID:0,
      StatusID :5, 
      StatusName :"Educational Details",  
      StatusFlag :"N", 
      profilePicPath:"../../../../assets/app/media/img/users/student.jpg",
      chk:false
    },
    {
      StudentID:0,
      StatusID :6, 
      StatusName :"Social Reservation",  
      StatusFlag :"N", 
      profilePicPath:"../../../../assets/app/media/img/users/student.jpg",
      chk:false
    },
    {
      StudentID:0,
      StatusID :7, 
      StatusName :"Common Document",  
      StatusFlag :"N", 
      profilePicPath:"../../../../assets/app/media/img/users/student.jpg",
      chk:false
    },
    {
      StudentID:0,
      StatusID :8, 
      StatusName :"Bank Details",  
      StatusFlag :"N", 
      profilePicPath:"../../../../assets/app/media/img/users/student.jpg",
      chk:false
    },
    {
      StudentID:0,
      StatusID :9, 
      StatusName :"Sports & Hobby",  
      StatusFlag :"N", 
      profilePicPath:"../../../../assets/app/media/img/users/student.jpg",
      chk:false
    },
];

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private dataService: DataAccessService, 
    private configuration : Configuration) { 
  }
  getGridColumns() {
    return gridColumns;
  }
  getSemisterWiseStudentList(){
    return semisterWiseStudent;
  }
  getUserDetails() {
    
    return  {
      userName: localStorage.getItem('currentUser'),
    }
  }
  getCourseColumns() {
    return courseColumns;
  }
  getPreStudentCourseColumns() {
    return PreStudentcourseColumns;
  }
  getExamColumns() {
    return examColumns;
  }
  GetprofileStatusdefault() {
    return profileStatusdefault;
  }
  public getdashboardData(StudentID,AcadamicInstanceID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetPreStudentInformationForDashboardByStudentID?StudentID='+ StudentID+'&AcademicInstanceID='+AcadamicInstanceID; // setting method name from API controller
    return this.dataService.getAll<PreStudentInformationDashBoard[]>()
  }
  public getPreStudentdashboardData(StudentID,AcadamicInstanceID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetPreStudentCourseForDashboardByStudentID?StudentID='+ StudentID+'&AcademicInstanceID='+AcadamicInstanceID; // setting method name from API controller
    return this.dataService.getAll<PreStudentInformationDashBoard[]>()
  }

  public GetImageANDSignByStudentID(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetImageANDSignByStudentID?StudentID='+ StudentID ; // setting method name from API controller
    return this.dataService.getAll<PreStudentInformationDashBoard[]>()
  }

  public GetUploadFileSize() {
    this.dataService.setControllerName = '/PreStudentAddressInfo/';
    this.dataService.setMethodName = 'GetUploadFileSize'; // setting method name from API controller
    return this.dataService.getAll<ImageSize[]>()
  }

  public GetPrintRecieptCET(StudentID,CourseID,CoursePartID,BranchID,PurposeCode,AcadamicInstanceID) {
    this.dataService.setControllerName = '/CollegePaymentTransDetails/';
    this.dataService.setMethodName = 'GetReceipt?StudentID=' + StudentID +'&CourseID='+CourseID+'&CoursePartID='+CoursePartID+'&BranchID='+ BranchID+'&PurposeCode='+PurposeCode+'&AcadamicInstanceID='+ AcadamicInstanceID;
    return this.dataService.getAll<Hallticket[]>()
  }
  public getExamdashboardData(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetPreStudentInformationOfExamListByStudentID?StudentID='+ StudentID ; // setting method name from API controller
   return this.dataService.getAll<PreStudentInformationDashBoard[]>()
  }
  public getdUserDetailsStatusFromPortal(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetUserDetailsStatusFromPortal?StudentID='+ StudentID ; // setting method name from API controller
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }
  public getupdateprofilelock(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'Getupdateprofilelock?StudentID='+ StudentID ; // setting method name from API controller
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }
  public GetProfileLockStatusForAdmissionForm(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetProfileLockStatusForAdmissionForm?StudentID='+ StudentID; // setting method name from API controller.
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }

  public getHallTicketByStudentID(StudentID) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetHallTicketReportByStudentID?StudentID='+ StudentID ; // setting method name from API controller
    return this.dataService.getAll<Hallticket[]>()
  }
  public GetPGCETHallTicketByStudentID(StudentID,CourseID,BranchID) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetPGCETHallTicketByStudentID?StudentID='+ StudentID +'&CourseID='+CourseID+'&BranchID='+BranchID ; // setting method name from API controller
    return this.dataService.getAll<Hallticket[]>()
  }
  public GetUpdateMeritAcceptFlag(StudentID,CourseID,BranchID,CollegeID,  CoursePartID,  AcademicInstanceID) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetUpdateMeritAcceptFlag?StudentID='+ StudentID +'&CourseID='+CourseID+'&BranchID='+BranchID+'&CollegeID='+CollegeID+'&CoursePartID='+CoursePartID+'&AcademicInstanceID='+AcademicInstanceID+'' ; 
    return this.dataService.getAll<Hallticket[]>()
  }
  public GetInitializeMeritPayment(StudentID,CourseID,BranchID,CollegeID,  CoursePartID,  AcademicInstanceID) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetInitializeMeritPayment?StudentID='+ StudentID +'&CourseID='+CourseID+'&BranchID='+BranchID+'&CollegeID='+CollegeID+'&CoursePartID='+CoursePartID+'&AcademicInstanceID='+AcademicInstanceID+'' ; 
    return this.dataService.getAll<Hallticket[]>()
  }
  public getFormByStudentID(StudentID) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetRegistrationFormPrint?StudentID='+ StudentID ; // setting method name from API controller
    return this.dataService.getAll<Hallticket[]>()
  }
  public GetRegistrationFormPrintByCourseAndBranch(StudentID,CourseID,BranchID,AcademicInstanceID,CollegeID) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetRegistrationFormPrintByCourseAndBranch?StudentID='+ StudentID +'&CourseID='+CourseID+'&BranchID='+BranchID+'&AcademicInstanceID='+AcademicInstanceID +'&CollegeID='+CollegeID; // setting method name from API controller
    return this.dataService.getAll<Hallticket[]>()
  }
  public GetStudentEligibilityApplicationFormReport(StudentID,CoursePartID,BranchID,AcademicInstanceID) {
    this.dataService.setControllerName = '/AdmissionReport/';
    this.dataService.setMethodName = 'GetStudentEligibilityApplicationFormReport?StudentID='+ StudentID +'&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&AcademicInstanceID='+AcademicInstanceID ;
    return this.dataService.getAll<Hallticket[]>()
  }
  public getEntCourse(StudentID) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetEntPreStudentCourseStatusByStudentID?StudentID='+ StudentID ; // setting method name from API controller
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }
  public getEntCourseBystudentIDANDCollegeID(StudentID,CourseID,BranchID,CollegeID) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetEntPreStudentCourseStatusByStudentIDANDCollegeID?StudentID='+ StudentID+'&CourseID='+CourseID+'&BranchID='+BranchID+'&CollegeID='+CollegeID; // setting method name from API controller
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }

  public GetPreStudentCourseStatusByStudentIDANDCollegeID(StudentID,CourseID,BranchID,CollegeID) {
    this.dataService.setControllerName = '/PreStudentCourse/';
    this.dataService.setMethodName = 'GetPreStudentCourseStatusByStudentIDANDCollegeID?StudentID='+ StudentID+'&CourseID='+CourseID+'&BranchID='+BranchID+'&CollegeID='+CollegeID; // setting method name from API controller
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }
  public getEntTimeTable(CourseID,CollegeID,BranchID,EntranceExamFlag) {
    this.dataService.setControllerName = '/EntTimeTable/';
    this.dataService.setMethodName = 'GetScheForEntTimeTable?CourseID='+CourseID+'&CollegeID='+CollegeID+'&BranchID='+ BranchID + '&EntranceExamFlag=' + EntranceExamFlag + ''; // setting method name from API controller
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }
  public GetUpdateApplicationCancelStatusByStudentID(StudentID,CourseID,BranchID,CollegeID,EntranceExamFlag) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetUpdateApplicationCancelStatusByStudentID?StudentID='+ StudentID + '&CourseID='+ CourseID + '&BranchID=' + BranchID + '&CollegeID='+ CollegeID + '&EntranceExamFlag=' + EntranceExamFlag + ''; 
    return this.dataService.getAll<Hallticket[]>()
  }

  public GetAdmissionPaymentReceipt(StudentID,CourseID,BranchID,AcademicInstanceID,CollegeID) {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetAdmissionPaymentReceipt?StudentID='+ StudentID +'&CourseID='+CourseID+'&BranchID='+BranchID+'&AcademicInstanceID='+AcademicInstanceID +'&CollegeID='+CollegeID; // setting method name from API controller
    return this.dataService.getAll<Hallticket[]>()
  }

  public GetExamDashbordByStudentIDANDCoursePartID(StudentID,CoursePartID,BranchID,AcademicInstanceID) {
    this.dataService.setControllerName = '/PreStudentExam/';
    this.dataService.setMethodName = 'GetExamDashbordByStudentIDANDCoursePartID?StudentID='+ StudentID +'&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&AcademicInstanceID='+AcademicInstanceID ; // setting method name from API controller
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }

  public GetPRNNOPortalDashboard(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetPRNNOPortalDashboard?StudentID='+ StudentID; 
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }

  public GetOnlineStatementofMarksByPRNNO(PRNNO,ExamInstanceID) {
    this.dataService.setControllerName = '/MeritListReport/';
    this.dataService.setMethodName = 'GetOnlineStatementofMarksByPRNNO?PRNNO='+ PRNNO +'&ExamInstanceID='+ExamInstanceID ; 
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }

  public GetStudentHallTicketInStudentLogin(StudentID) {
    this.dataService.setControllerName = '/PreStudentExam/';
    this.dataService.setMethodName = 'GetStudentHallTicketInStudentLogin?StudentID='+ StudentID; 
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }

  public GetHallTicketandMarksheetFlag(CoursePartID,BranchID,ExamInstanceID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetHallTicketandMarksheetFlag?CoursePartID='+ CoursePartID +'&BranchID='+BranchID+'&ExamInstanceID='+ExamInstanceID; 
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }
}
